export default __webpack_public_path__ + "locales/es/DeleteProfileEverDialog.json?hash=98ddc745c7aa98c7c1b8fcdc8394641d";